module.exports = __webpack_public_path__ + "static/media/icon-medidor-cinza.65fdec7c.svg";